import entireAudio from '../../factories/entire-audio';

export const entireAudioEnhancer = entireAudio('audiogramWizard');
